import {
  AudioWaveform, Bot, Clapperboard, Drama, Mountain, PartyPopper, Radio, Sparkles, Wand, MicVocal, type LucideIcon,
} from 'lucide-react';

export const CATEGORY_ICONS: Record<string, LucideIcon> = {
  robot: Bot,
  funny: PartyPopper,
  character: Drama,
  tapori: MicVocal,
  radio: Radio,
  environment: Mountain,
  studio: Sparkles,
  filmy: Clapperboard,
  tools: Wand,
};

export function categoryIcon(id: string): LucideIcon {
  return CATEGORY_ICONS[id] ?? AudioWaveform;
}

export const CATEGORY_VAR = (id: string) => `var(--cat-${id})`;
